import "./quote_hero_module.css";